export default {"main":"_4T03Ba_main","column":"_4T03Ba_column","heading":"_4T03Ba_heading","list":"_4T03Ba_list",}